






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Publish extends Vue {
  private arrow: string = "never";
  // 0:出版社 1:合作机构
  @Prop() private type!: number;
  @Prop() private dotShowLen!: number;
  @Prop() private datas!: [];
}
